import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchStaffRoles} from './actions';
import {bindActionCreators} from "redux";
import {Link} from 'react-router-dom';

import permissions from "./permissions";
import ListView from "../common/ListView";

const permissionsMap = permissions.reduce((a,c) => ({...a, [c.value]: c.text}), {});

class StaffRolesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    searchStaffRoles: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
  };

  render() {
    const {
      history, searchStaffRoles,
      search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Permissions',
        dataIndex: 'permissions',
        key: 'permissions',
        render: (value) => value.map(x => permissionsMap[x]).join(", ")
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {staffRoleId}) => <Link to={`/staff-role/update/${encodeURIComponent(staffRoleId)}`}>Edit</Link>
      }
    ];
    return (
      <ListView
        title="Roles"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchStaffRoles}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        rowKey="staffRoleId"
        onAdd={() => history.push('/staff-role/add')}
      />
    );
  }
}

const mapStateToProps = state => ({
  search: state.staffRole.search,
});

const mapDispatchToProps = dispatch => ({
  searchStaffRoles: bindActionCreators(searchStaffRoles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffRolesPage);



// WEBPACK FOOTER //
// ./src/StaffRole/StaffRolesPage.js